import React from 'react'
import styled, { keyframes } from 'styled-components'

const Rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`

const SpinnerCircle = styled.circle<{
  animationDelay: string
  animationSpeed: string
}>`
  stroke-dasharray: 80;
  stroke-dashoffset: 60;
  transform-origin: 50% 50%;
  animation: ${Rotate} ${({ animationSpeed }) => animationSpeed} linear infinite;
  animation-delay: ${({ animationDelay }) => animationDelay};
`

interface PendingSpinnerProps extends React.SVGProps<SVGSVGElement> {
  animationDelay?: string
  animationSpeed?: string
}

function PendingSpinner({
  animationDelay = '0s',
  animationSpeed = '1s',
  ...props
}: PendingSpinnerProps): React.ReactElement {
  return (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" strokeWidth={4} stroke="orange" {...props}>
      <SpinnerCircle
        cx="26"
        cy="26"
        r="20"
        fill="none"
        animationDelay={animationDelay}
        animationSpeed={animationSpeed}
      />
    </svg>
  )
}

export default PendingSpinner
